import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { USWDSButtonComponent } from "./button.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    USWDSButtonComponent
  ],
  exports: [
    USWDSButtonComponent
  ]
})
export class USWDSButtonModule {};
